import { Capacitor } from '@capacitor/core';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Preferences } from '@capacitor/preferences';
import { url } from '@/config/urls';

function normalizeNotificationData(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return {};
  }
  const out = {};
  for (const [k, v] of Object.entries(raw)) {
    out[k] = v != null ? String(v) : '';
  }
  return out;
}

class PushNotificationService {
  constructor() {
    this.cachedToken = null;
    this.pushTokenKey = 'push_token';
    this.tapHandlerRegistered = false;
  }

  /**
   * 通知バナー／ポップアップをタップしたとき（アプリ起動中・バックグラウンドから復帰時）
   * FCM data の pushType に応じて画面遷移する
   */
  registerTapHandler(router) {
    if (this.tapHandlerRegistered) {
      return;
    }
    const platform = Capacitor.getPlatform();
    if (platform !== 'ios' && platform !== 'android') {
      return;
    }
    if (
      typeof Capacitor.isPluginAvailable !== 'function'
      || !Capacitor.isPluginAvailable('FirebaseMessaging')
    ) {
      return;
    }

    this.tapHandlerRegistered = true;

    FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
      const data = normalizeNotificationData(event.notification?.data);
      const pushType = data.pushType;
      let target = url.page.top;

      switch (pushType) {
        case '01':
          target = url.page.orderResults;
          break;
        default:
          target = url.page.top;
          break;
      }

      router.push(target).catch(() => {});
    });
  }

  async getPushToken() {
    const platform = Capacitor.getPlatform();
    if (platform !== 'ios' && platform !== 'android') {
      return null;
    }

    if (this.cachedToken) {
      return this.cachedToken;
    }

    try {
      const { value: storedToken } = await Preferences.get({ key: this.pushTokenKey });
      if (storedToken) {
        this.cachedToken = storedToken;
        return storedToken;
      }

      if (
        typeof Capacitor.isPluginAvailable !== 'function'
        || !Capacitor.isPluginAvailable('FirebaseMessaging')
      ) {
        console.log('[push] plugin unavailable: FirebaseMessaging');
        return null;
      }

      let permission = await FirebaseMessaging.checkPermissions();
      if (!permission || permission.receive === 'prompt') {
        permission = await FirebaseMessaging.requestPermissions();
      }
      if (permission.receive !== 'granted') {
        console.log('[push] permission denied');
        return null;
      }

      const { token } = await FirebaseMessaging.getToken();
      if (token) {
        this.cachedToken = token;
        await Preferences.set({ key: this.pushTokenKey, value: token });
      }
      return token ?? null;
    } catch (error) {
      console.error('[push] Pushトークン取得エラー:', error);
      return null;
    }
  }
}

const pushNotificationService = new PushNotificationService();
export default pushNotificationService;
